module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (hasPrevPage()) { 
__p+='<li class="js-prev-page">previous page</li>';
 } 
__p+='\n';
 if (getTotalPages() > 1) { 
__p+='\n\n	';
 _.forEach(paginationItems(), function(item) { 
__p+='\n		';
 if (item.type === 'page') { 
__p+='\n			<li class="js-goto-page ';
 if (item.current) {
__p+='active';
 } 
__p+='" data-page="'+
((__t=( item.value ))==null?'':__t)+
'">'+
((__t=( item.value+1 ))==null?'':__t)+
'\n		';
 } 
__p+='\n		';
 if (item.type === 'seperator') { 
__p+='<li class="seperator">...</li>';
 } 
__p+='\n	';
 }) 
__p+='\n';
 } 
__p+='\n';
 if (hasNextPage()) { 
__p+='<li class="js-next-page">next page</li>';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/behaviors/collection_pagination/templates/pagination.html
// module id = 400
// module chunks = 0